import { Box, Typography, Button } from "@mui/material";
import { Link } from "react-router-dom";
import { C, FONT, outlineButtonSx } from "./accountStyles";
import PaymentResult from "./components/PaymentResult";


export default function CancelPage() {
  return (
    <PaymentResult
      id="payment-cancel-title"
      closeTo="/home"
      closeLabel="close"
      maxWidth={480}
      title="Payment Cancelled"
      icon={
        <Box
          aria-hidden="true"
          sx={{
            width: 64,
            height: 64,
            mx: "auto",
            mb: 2,
            borderRadius: "50%",
            border: `1.5px solid ${C.danger}`,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" stroke={C.danger} strokeWidth="2" viewBox="0 0 24 24">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </Box>
      }
      action={
        <Button component={Link} to="/home" variant="outlined" fullWidth sx={{ ...outlineButtonSx, minHeight: 48 }}>
          Try Again
        </Button>
      }
    >
      <Typography sx={{ fontFamily: FONT, color: C.text, fontSize: "1.05rem", lineHeight: 1.6 }}>
        Your payment has been cancelled. If this was a mistake, you can try again or contact support.
      </Typography>
    </PaymentResult>
  );
}
